// extracted by mini-css-extract-plugin
module.exports = {"title":"e_uf","container":"e_vf","right":"e_wf","image":"e_xf","scoreLine":"e_yf","scoreRing":"e_zf","badge":"e_Af","badgeImage":"e_Bf","badgeRing":"e_Cf","large":"e_Df"};